import { render, staticRenderFns } from "./NewInformGroupDialog.vue?vue&type=template&id=31139bd6&scoped=true"
import script from "./NewInformGroupDialog.vue?vue&type=script&lang=js"
export * from "./NewInformGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./NewInformGroupDialog.vue?vue&type=style&index=0&id=31139bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31139bd6",
  null
  
)

export default component.exports